import React, { useState, useRef, useEffect, useMemo } from "react";

const MarketMultiSelect = ({
  marketData,
  isLoadingLeagueData,
  Messages,
  handleSelectionChange,
  setMastermarketid,
}) => {
  const [selectedMarkets, setSelectedMarkets] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  // Memoize filtered market data
    const filteredMarketData = useMemo(() => {
      if (!searchTerm) return marketData; // If no search term, return all data
  
      const filtered = marketData.filter((item) =>
        item.marketname.toLowerCase().includes(searchTerm.toLowerCase())
      );
  
      return filtered.length > 0 ? filtered : [];
    }, [marketData, searchTerm]);
  

  const toggleLeague = (leagueId) => {
    setSelectedMarkets((prevSelected) => {
      const updatedSelection = prevSelected.includes(leagueId)
        ? prevSelected.filter((id) => id !== leagueId)
        : [...prevSelected, leagueId];
      setMastermarketid(updatedSelection);
      return updatedSelection;
    });
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="dropdown-container" ref={dropdownRef}>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedMarkets.length > 0
          ? (() => {
              const marketNames = selectedMarkets
                .map(
                  (id) =>
                    marketData.find((item) => item.mastermarketid === id)
                      ?.marketname
                )
                .filter(Boolean);
              return marketNames.length > 2
                ? `${marketNames.slice(0, 2).join(", ")}...`
                : marketNames.join(", ");
            })()
          : "Choose Market"}
        <span className={`dropdown-arrow ${isOpen ? "open" : ""}`}></span>
      </div>
      {isOpen && (
        <div className="dropdown-list">
          <div className="AF-formControl_tribet">
            <input
              type="text"
              placeholder="Search Markets..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              id="input_treble_search_market"
            />
          </div>

          {!isLoadingLeagueData ? (
            filteredMarketData.length > 0 ? (
              filteredMarketData.map((item) => (
                <div
                  key={item.mastermarketid}
                  className="AF-formControl_multibet"
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`multibet_market-${item.mastermarketid}`}
                    value={item.mastermarketid}
                    checked={selectedMarkets.includes(item.mastermarketid)}
                    onChange={() => toggleLeague(item.mastermarketid)}
                  />
                  <label
                    className="label"
                    htmlFor={`market-${item.mastermarketid}`}
                  >
                    {item.marketname}
                  </label>
                </div>
              ))
            ) : (
              <div className="text-muted">
                {Messages.tournamentsNotAvailable}
              </div>
            )
          ) : (
            <div className="text-muted">{Messages.apiLoading}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default MarketMultiSelect;
